import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {IntlShape} from 'react-intl'
import {
  IdentityCell,
  BooleanCell,
  LastSeenCell,
  DateCell,
  RoleCell,
  UserStatusCell,
  ActionsCell,
  CustomHeader
} from '@/components/table/columns'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
} as Intl.DateTimeFormatOptions

const getColumns = (intl: IntlShape) : ReadonlyArray<Column<Model>> => [{
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.LIST.TABLE.COL_USER'})} className='min-w-125px'/>,
  id: 'lastname',
  Cell: ({...props}) =>
    <IdentityCell
      email={props.data[props.row.index].email}
      displayName={props.data[props.row.index].lastname + ' ' + props.data[props.row.index].firstname}
      to={`/app/users/${props.data[props.row.index]._id}/overview`}
    />
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.LIST.TABLE.COL_ROLE'})} className='min-w-125px' />
  ),
  id: 'role',
  Cell: ({...props}) => <RoleCell role={props.data[props.row.index].role} />,
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.LIST.TABLE.COL_STATUS'})} className='min-w-75px' />
  ),
  id: 'status',
  Cell: ({...props}) => <UserStatusCell status={props.data[props.row.index].statuses.at(-1)} />
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.LIST.TABLE.COL_2FA'})} className='min-w-75px text-center' />
  ),
  id: '2fa',
  Cell: ({...props}) => <BooleanCell value={props.data[props.row.index].is2FA} type="icon"/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.LIST.TABLE.COL_CREATEDAT'})} className='min-w-125px' />,
  id: 'createdAt',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].createdAt} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.LIST.TABLE.COL_LAST_SEEN'})} className='min-w-125px' />,
  id: 'lastSeen',
  Cell: ({...props}) => <LastSeenCell value={props.data[props.row.index].lastSeen} />
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title={intl.formatMessage({id:'COMPONENT.TABLE.COL.ACTIONS'})} className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'magnifier',
        label: intl.formatMessage({id: 'CORE.USERS.LIST.TABLE.COL.ACTION.VIEW_USER'}),
        navigate:  `/app/users/${props.data[props.row.index]._id}/overview`
      }]}
    />
  )
}]

export {getColumns}
